import { createFeatureSelector, createSelector } from '@ngrx/store';

import { UserConfigurationPartialState } from '.';
import { USER_CONFIGURATION_MODULE_KEY } from './user-configuration.declarations';

const getFeatureState = createFeatureSelector<UserConfigurationPartialState>(
  USER_CONFIGURATION_MODULE_KEY
);

/** state */
const getUserConfigurationState = createSelector(getFeatureState, feat => feat.userConfiguration);

/** configs */
const getCalendarConfiguration = createSelector(
  getUserConfigurationState,
  state => state.calendarConfiguration
);

const getExternalProvidersConfiguration = createSelector(
  getUserConfigurationState,
  state => state.externalProvidersConfiguration
);

export const userConfigurationQuery = {
  getUserConfigurationState,
  getCalendarConfiguration,
  getExternalProvidersConfiguration
};
